/**
 * Linguistic Observer Utility
 * Analyzes ontological connectors to detect worker mentality patterns.
 * 
 * "Y" -> Generativo (Growth/Possibility)
 * "Pero" -> Resistencia (Resistance/Conflict)
 * "¿Por qué?" -> Victimización (Victimhood/Externalization)
 */

export function analyzeLinguisticPattern(text) {
    if (!text) return { y: 0, pero: 0, por_que: 0, pattern: 'neutral' };

    const cleanText = text.toLowerCase();
    
    const counts = {
        y: (cleanText.match(/\by\b/g) || []).length,
        pero: (cleanText.match(/\bpero\b/g) || []).length,
        por_que: (cleanText.match(/¿?por qué\??/g) || []).length
    };

    // Determine dominant pattern
    let pattern = 'generativo';
    if (counts.por_que > 0) pattern = 'victimizacion';
    else if (counts.pero > counts.y) pattern = 'resistencia';
    else if (counts.y >= counts.pero) pattern = 'generativo';

    return { ...counts, pattern };
}
